/**
 * Utility functions for device detection
 */
// Check if the device is Android (using the user agent)
export const isAndroid = () => /Android/i.test(navigator.userAgent);

// Check if the device is iOS (iPhone, iPad, or iPod)
export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
